import { NgModule } from '@angular/core';
import { Component, OnInit, Inject, ViewChild, ElementRef, Renderer  } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface AlertaInput {
    tituloAlerta: string;
    textoAlerta: string;
    tipoInput: string;
    textoCancel: string;
    textoConfirm: string;
    textoInput: string;
    valorInput: string;
    nomeInput: string;
    beFocused: boolean;
    textoCaption: string;

    // textoCheck: string;
    // checkAlerta: boolean;
}

@Component({
    selector: 'alerta-input',
    templateUrl: './alerta-input.html',
    styleUrls: ['./alerta-input.css']
  })
  export class AlertaInputDialog {
    @ViewChild("inputIA") inputEl: ElementRef;
    public mvpMask: any;
    public maskRoad: any;
    constructor(
      public dialogRef: MatDialogRef<AlertaInputDialog>,
      @Inject(MAT_DIALOG_DATA) public data: AlertaInput, private elRef: ElementRef, private renderer: Renderer) {}
  

    ngOnInit(){
      if(this.data.nomeInput == 'nascimento'){
        this.mvpMask =  {mask :  [ /[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] };
      }
      if(this.data.nomeInput == 'altura'){
        //this.mvpMask =  {mask :  [ /[0-9]/,',', /\d/, /\d/] };
        this.mvpMask =  {mask : false };
      }
      if(this.data.nomeInput == 'celular'){
        this.mvpMask =  {mask :   ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,/\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/] };
      }
      if(this.data.nomeInput == 'peso' || this.data.nomeInput == 'nome' || this.data.nomeInput == 'nick' || this.data.nomeInput == 'frase' || this.data.nomeInput == 'nomemodelo' || this.data.nomeInput == 'email' ){
        this.mvpMask =  {mask : false };
      }
      setTimeout(() => {

      
        //document.activeElement.blur();
        
        // this.renderer.invokeElementMethod(
        //   this.elRef.nativeElement.ownerDocument.activeElement, 'blur');

        //this.elRef.nativeElement.blur();
        if (this.data.beFocused){
          console.log("should focus");
          this.inputEl.nativeElement.focus();
        }
      }, 500);
    }

    onNoClick(): void {
      this.dialogRef.close(false);
      this.inputEl.nativeElement.focus();
      //return false;
    }
    onConfirmClick() :void {
      console.log("clicou");
      
      // console.log(this.data.checkAlerta);
      // if(this.data.textoCheck !== undefined){
      //   console.log(this.data.checkAlerta);
      //   return;
      // }
   
      this.dialogRef.close(this.data.valorInput);
      this.inputEl.nativeElement.focus();
        // if (this.data.valorInput == '' || this.data.valorInput == undefined){

        // }
        // else{
        //   this.dialogRef.close(this.data.valorInput);
        // }
        
    }
  
}